import React, { Component } from "react";
import {  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader, } from "reactstrap";
import Swal from "sweetalert2";
import Axios from "axios";
import { configuration } from "../appConfig";
import { calculatePrice } from "../pricing/calculatePrice";
import { connect } from "react-redux";
import { updateJsonData } from "../redux/actions/updateJsonData";
import NewpolandPriceTable from "./common/NewpolandPriceTable";
import Newswiss_CustomerInfoTable from "./common/newswiss_CustomerInfoTable";
import Select from "react-select";
import DuplicateVinModal from "./DuplicateVinModal";
import DamageToggleButton from "./common/DamageToggleButton";
import axios from "axios";
import { toggleDamageImages } from "../redux/actions/showReportDamageImage";


let zurichArr = ['zürich', 'zurich', 'zurigo', 'zurich', 'z%c3%bcrich+versicherung']; 

function findWithAttr(array, attr, value) {
  for(var i = 0; i < array.length; i += 1) {
      if(array[i][attr] === value) {
          return i;
      }
  }
  return -1;
}

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class TabViewPoland extends Component {
  state = {
    selectedFile: "",
    order: {
      vinNumber: "",
      orderNumber: "",
      issuedOn: new Date(),
    },
    partDetails: null,
    twoDView: true,
    vinNumber: null,

    vinfolderList: [],
    showTwoDView: true,
    selectedPartInfo: [],
    scanresult: [],
    swissTable: [],
    // fullData:[],
    isTableUpdated: false,
    loading:false,
    Authorized: false,
    words : {},
    lang: "",
    jsonData : {},
    deAuthLoading : false,
    restoreDataloading : false,
    isJSONLoading: false,
    duplicateVinModal: false,
      IsPriceTableUpdated: false,
      selectedPartnerIdList: [],
      selectedPartnerId: "",
      showDamageImages: 0,
      showReportDamageImages: false,
    // DATLoading : false
  };
  count = [];
  
  componentDidMount() {
    const selectedFile = localStorage.getItem("selectedFile");
    this.setState({ vinNumber: selectedFile });
    this.getData(selectedFile);
    this.vinFolderList();
    this.getLang();
  }
  componentWillReceiveProps(nextProps,prevState) {
    if (nextProps.fullData) {
      this.setState({
        Authorized: nextProps.fullData.Authorized,
        fullData : nextProps.fullData
      })
    } 
    if (nextProps.lang !== prevState.lang) {
      this.setState({ lang: nextProps.lang })
    } else {return}
  }
  getData = async(selectedFile,type) => {
    this.setState({
      isJSONLoading: true,
    })
    axios.get(
        `${configuration.getData}?vin=${selectedFile}&partnerId=${localStorage.getItem("partnerId")}`
      ).then((r) => {
        if(r.data.Authorized){
          this.setState({
            customerCompany: r.data.CustomerCompany ? r.data.CustomerCompany : '', 
            Authorized: r.data.Authorized,
            jsonData : r.data,
            DATReportAuthorized: r.data.DATReportAuthorized,
          IsPriceTableUpdated: r.data.IsPriceTableUpdated || false,

          })
        }else{
            this.setState({
              customerCompany: r.data.CustomerCompany ? r.data.CustomerCompany : '', 
              Authorized: false,
              jsonData : r.data,
              DATReportAuthorized: r.data.DATReportAuthorized,
          IsPriceTableUpdated: r.data.IsPriceTableUpdated || false,

          })
        }
        this.setState(
          {
            showReportDamageImages:
              r.data &&
              r.data.DamageImageToggle &&
              r.data.DamageImageToggle,
          },
          () => {
            this.getFallBackDetails();
          }
        );
        this.setState({
          isJSONLoading: false
        })
      }).catch(error=> {
        alert('An error occured please try again')
        this.setState({
          isJSONLoading: false
        })
      });
  }
  getFallBackDetails = async () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    await axios
      .get(url)
      .then((response) => {
        if (response && response.data) {
          this.setState({
            showDamageImages: response.data.is_damage_image,
            isUnviversalScan : response.data.is_universal_scan
          });
          if (
            this.state.showReportDamageImages === undefined ||
            this.state.showReportDamageImages === null
          ) {
            this.setState({
              showReportDamageImages:
                response.data.is_default_damage_image == 1 ? true : false,
            });
          }
          this.props.toggleDamageImages(this.state.showReportDamageImages);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  handleChange = (e) => {
    this.setState({
      customerInfo: {
        ...this.state.customerInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  customerInfo = async () => {
    //alert('No Partner Id selected! Please login.')

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({ customerInfo: res.data[0] });
      }
    } else {
      // this.props.history.push('/login');
      // alert('No Partner Id selected! Please login.')
    }
  };

  calPrice = (average, count) => {
    let pp = calculatePrice(average, count);
    //this.count.push(pp)
    return (pp * 130) / 6;
  };
  calUnit = (average, count) => {
    let pp = calculatePrice(average, count);
    this.count.push(pp);
    return pp;
  };
  vinFolderList = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    if (partnerId) {
      const response = await Axios.get(
        configuration.resultTxt +
          "?vin=" +
          selectedFile +
          "&partnerId=" +
          partnerId
      );

      if (response.data[0] && response.data[0].resultTXT) {
        this.setState({
          vinfolderList: response.data,
          scanresult: response.data[0].resultTXT,
        });
        response.data[0].resultTXT.scanresult && this.countDetails(response.data[0].resultTXT.scanresult);
      } else {
        // alert('Data not available.')
      }
    } else {
      this.props.history.push("/login");
    }
  };
  countDetails = async (rowArray) => {
    let promises = [];
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    for (let i = 0; i < rowArray.length; i++) {
      // if (rowArray[i].Amount) {
      let url =
        configuration.GetPartDetails +
        "?vin=" +
        vin +
        "&partnerId=" +
        partnerId +
        "&part=" +
        rowArray[i].part;
      //promises.push(url);
      promises.push(Axios.get(url));
      // }
    }

    const arrRes = await Axios.all(promises);

    const ltgtdata = arrRes.map((result) => {
      let ltcount = 0;
      let gtcount = 0;
      let val = result.data && result.data.json.split("\r\n");

      val.map((r) => {
        let val2 = r.split(" ")[3];

        if (val2 && parseInt(val2) > 25) {
          gtcount = gtcount + 1;
        }
        if (val2 && parseInt(val2) < 26) {
          ltcount = ltcount + 1;
        }
        return val2;
      });

      return {
        part: result.data.part,
        count: val.length - 1,
        lt25: ltcount,
        gt25: gtcount,
        ltunit: calculatePrice(24, ltcount),
        gtunit: calculatePrice(26, gtcount),
      };
    });
    this.setState({ swissTable: ltgtdata });
    console.table(ltgtdata);
    //return 5
  };

  selectFile = (e) => {
    localStorage.setItem("selectedFile", e.target.value);
    this.setState({ selectedFile: e.target.value });
  };
  showDummyData = () => {
    //this.getData(this.state.selectedFile);
    this.customerInfo();
  };

  SizeDropdown = (size, index) => {
    const arr = [0, 10, 20, 30, 40, 50, 60, 70, 80];
    return (
      <select value={size} onChange={(e) => this.change(e.target.value, index)}>
        {arr.map((row, i) => (
          <option key={i}>{row}</option>
        ))}
      </select>
    );
  };
  change = (val, index) => {
    //
    const { scanresult } =
      this.state.vinfolderList.length && this.state.vinfolderList[0].resultTXT;

    scanresult[index].size = val;
    this.setState({ scanresult });
    const result = window.confirm("Are you sure want to change Size?");
    if (result) {
      const url = configuration.Update_ResultTxt;
      let payload = {
        scanresult: scanresult,
        partnerId: localStorage.getItem("partnerId"),
        vin: localStorage.getItem("selectedFile"),
      };
      Axios.post(url, payload).then((res) => {
        Toast.fire({
          type: "success",
          title: "Data saved successfully",
        });
      });
    }
  };
  handleChange = (row, value, index) => {
    if (value > 0) {
      row.size = value;
      //let dd = this.state.vinfolderList[0].resultTXT.scanresult[index];
      this.setState({ dd: row });
    }
  };
  changeCount = (row, value, index) => {
    if (value >= 0) {
      row.Amount = value;
      //  let countRow = this.state.vinfolderList[0].resultTXT.scanresult[index];
      this.setState({ countRow: row });
    }
  };
  Update = () => {
    const url = configuration.Update_ResultTxt;
    let data = this.state.vinfolderList[0].resultTXT;
    data.partnerId = localStorage.getItem("partnerId");

    Axios.post(url, data).then((res) => {
      alert("data updated");
    });
  };

  authorize = async () =>{
    // for get updated JSON
    // this.getData(localStorage.getItem("selectedFile"),"Authorized");
    const { fullData} = this.state
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url1 =
    configuration.PostEditorChanges +
    `?partnerId=${partnerId}&vin=${vin}`;

    this.setState({
      loading:true
    })
    let totalDents = 0;
    await fullData && fullData.Dents && fullData.Dents.length && fullData.Dents.map((row,i) => {
      if(row.Part === 'TrunkCover'){
        fullData.Dents[i]['A'] = fullData.Dents[i]['A'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'];
        fullData.Dents[i]['B'] = fullData.Dents[i]['B'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'];
        fullData.Dents[i]['C'] = fullData.Dents[i]['C'] + fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'];
        fullData.Dents[i]['TotalDents'] = fullData.Dents[i]['A']+ fullData.Dents[i]['B']+ fullData.Dents[i]['C'];
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['A'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['B'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['C'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['TotalDents'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaMm'] = 0; 
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AvgDiaPx'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWa'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWb'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AWc'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['AW'] = 0;
        fullData.Dents[findWithAttr(fullData.Dents, 'Part', 'Trunk')]['Price'] = 0;
      }
      if(row.Part !== 'Trunk') {
        totalDents += (parseInt(row.A) ? parseInt(row.A) : 0) + (parseInt(row.B) ? parseInt(row.B) : 0) + (parseInt(row.C) ? parseInt(row.C) : 0);
      }
    })
    this.setState({
      fullData : {...this.state.fullData,'TotalDentCount': totalDents}
    },async () => {

      let payload = {
        ...this.state.fullData,
        Authorized: true,
        DATReportAuthorized: false 
      }
      const url = configuration.generatePDF;
      await Axios.post(url1,{...fullData,Authorized: false})
          .then(async (res) => {
      await Axios.post(url, {
        partnerId,
        vin
      }).then((res) => {
        this.state.fullData.Authorized = true
        if(res.data.status === 200){
          Axios.post(url1,payload)
          .then((res) => {
            this.setState({
              loading:false,
              Authorized:true, //for updating local state instantly
              DATReportAuthorized: false
            })
            Toast.fire({
              type: "success",
              title: "PDF generated successfully!",
            });
            this.props.updateJsonData(this.state.fullData);
          }).catch(err=>{
            this.setState({
              loading:false
            })
            // alert("Table update failed");
            Toast.fire({
              type: "error",
              title: "Table update failed",
            });
          });
        } else if (res.data.status === 500){
          this.setState({
            loading:false,
          })
          // vin or partner Id missing
          Toast.fire({
            type: "error",
            title: "Something went wrong!",
          });
        } else {
          this.setState({
            loading:false,
          })
          Toast.fire({
            type: "error",
            title: "pdf generate failed",
          });
        }
        // alert("data updated");
      }).catch(err=>{
        this.setState({
          loading:false
        })
        Toast.fire({
          type: "error",
          title: "pdf generate failed",
        });
      });
    })
  })
  }
  deAuthorize = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url1 =
    configuration.PostEditorChanges +
    `?partnerId=${partnerId}&vin=${vin}`;
    this.setState({
      deAuthLoading:true
    })
    this.state.fullData.Authorized = false
    let payload = {
      ...this.state.fullData,
      Authorized: false,
      DATReportAuthorized: false
    }
    Axios.post(url1,payload).then((res) => {
      Toast.fire({
        type: "success",
        title: "De-Authorize PDF successfully!",
      });
      this.setState({
        Authorized : false,
        deAuthLoading: false,
        DATReportAuthorized: false
      })
    this.props.updateJsonData(this.state.fullData);
    }).catch(err=>{
      this.setState({
        deAuthLoading: false
      })
      alert("Table update failed");
    });
  }
  getUpdatedStateFromPriceTable = (isTableUpdated) =>{
    this.setState({
      isTableUpdated:isTableUpdated
    })
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };

  handleRestoreJson = () => {
    this.setState({
      restoreDataloading : true
    })
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    let url = `${configuration.restoreJsonBackup}?partnerId=${partnerId}&vin=${vin}`
    Axios.get(url).then((res) => {
      if (res.data.status === 200) {
        Toast.fire({
          type: "success",
          title: "JSON restored successfully!",
        })
        this.setState({
          restoreDataloading : false
        })
        setTimeout(() => {
          window.location.reload();
        }, 5000)
      } else if (res.data.status === 400) {
        this.setState({
          restoreDataloading : false
        })
        Toast.fire({
          type: "error",
          title: "Failed to restore JSON!",
        })
      } else if (res.data.status === 404) {
        this.setState({
          restoreDataloading : false
        })
        Toast.fire({
          type: "error",
          title: "JSON backup not found!",
        })
      }
    }).catch((err) => {
      this.setState({
        restoreDataloading : false
      })
      Toast.fire({
        type: "error",
        title: "Something went wrong!",
      })
    })
  }
  openDuplicateVinModal = (clearValue) => {
    this.setState({ duplicateVinModal: !this.state.duplicateVinModal });
    if (clearValue) {
      this.setState({selectedPartnerId : ""})
    }
    if (
      this.props.selectedPartnerId &&
      this.props.selectedPartnerId.length > 0
    ) {
      const newOptions = this.props.selectedPartnerId.map((val) => ({
        label: val,
        value: val,
      }));

      this.setState({ selectedPartnerIdList: newOptions });
    }
  };

  handleSelectedPartnerId = (selectedOptions) => {
    this.setState({ selectedPartnerId: selectedOptions });
  };
  handleToggleDamageImages = (e) => {
    const showReportDamageImages = e.target.checked;
    this.setState({
      showReportDamageImages,
    });
    this.props.toggleDamageImages(showReportDamageImages);
    this.updateToggleDamageImages(showReportDamageImages);
  };
  updateToggleDamageImages = async (showReportDamageImages) => {
    console.log(showReportDamageImages);
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url =
      configuration.PostEditorChanges +
      `?partnerId=${partnerId}&vin=${vin}&TabViewUpdated=${true}`;
    const payload = {
      ...this.state.jsonData,
      DamageImageToggle: showReportDamageImages,
    };
    await axios
      .post(url, payload)
      .then((response) => {
        if (response && response.data && response.data.status == 200) {
          Toast.fire({
            type: "success",
            title: "Data saved successfully",
          });
          this.getData(vin);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  render() {
    //const selectedFile = localStorage.getItem("selectedFile");
   const client =  localStorage.getItem("client")
    const { orderNumber } = this.state.order;
    const { customerCompany, isJSONLoading,Authorized,
      IsPriceTableUpdated,
      duplicateVinModal,
      selectedPartnerIdList,
      selectedPartnerId, } = this.state;
    const showDuplicateVinBtn = this.props.isDuplicateVin == 1 ? true : false;
    const scanResult =
      this.state.vinfolderList.length && this.state.vinfolderList[0];
    scanResult.resultTXT && scanResult.resultTXT.scanresult &&
      scanResult.resultTXT.scanresult.filter((row) => {
        if (row.size) {
          let size = row.size - (row.size % 10);
          return (row.size = row.size % 10 >= 5 ? size + 10 : size);
        } else {
          return row;
        }
      });

    //const dentInfo = scanResult.resultTXT;
    const userSession = localStorage.getItem("userSession");
    const data = userSession ? JSON.parse(userSession) : {};
    const isZurichClient = customerCompany ? zurichArr.includes(customerCompany.split(' ')[0].toLowerCase()) : false;
    return (
      <div className="animated fadeIn">
        <Col xs="12" sm="12" className="p-2">
        <Card className="print_button_card">
            <CardHeader>
              <div className="container-fluid">
                <div className="row align-items-center p-0">
                  <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
                    <small> {client === "SWISS" || client === "POLAND" ?<span>{this.lang("DashboardVIN")} : </span> : <span>{this.lang("VIN Number")} : </span>} {localStorage.getItem("selectedFile")}</small>
                    {/* <small> <span>{this.lang("VIN Number")} :</span> {localStorage.getItem("selectedFile")}</small> */}
                  </div>
                  <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
                    <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
                    {showDuplicateVinBtn && (
                        <button
                          disabled={Authorized || !IsPriceTableUpdated}
                          className="glass btn mx-3 btn-lg btn-danger mr-1"
                          onClick={() => this.openDuplicateVinModal()}
                        >
                          {this.lang("Duplicate VIN")}
                        </button>
                      )}
                       {this.state.showDamageImages == "1" ||
                        this.state.showDamageImages == 1 ? (
                          <div className="d-flex align-items-center">
                            <DamageToggleButton
                              lang={this.lang}
                              showReportDamageImages={
                                this.state.showReportDamageImages
                              }
                              handleToggleDamageImages={
                                this.handleToggleDamageImages
                              }
                            />
                          </div>
                        ) : (
                          ""
                        )}
                    <button  className="glass btn mx-3 btn-lg btn-danger pull-right mr-1"
                     onClick={()=>this.handleRestoreJson()}
                     disabled={Authorized}
                     >
                      {this.lang("Restore Data")}
                    </button>
                      {/* <button  className={`glass btn mx-3 btn-lg btn-danger pull-right mr-1`} disabled={!this.state.Authorized || this.state.Authorized && this.state.DATReportAuthorized} onClick={()=>this.deAuthorize()}>
                        {this.state.deAuthLoading ? 
                          <div className="spinner-border" role="status" style={{width : "1.5rem", height : "1.5rem" }}>
                          <span className="sr-only">Loading...</span>
                        </div>
                        :
                          <i className="fa fa-print" />
                        }
                          &nbsp; {this.lang("De-Authorize PDF")}
                        </button> */}
                        {/* <button disabled={this.state.loading || this.state.Authorized} className={`glass btn btn-lg ${this.state.Authorized ? 'btn-success' : 'btn-danger'} pull-right mr-1`} onClick={this.authorize}>
                        {this.state.loading ? 
                          <div className="spinner-border" role="status" style={{width : "1.5rem", height : "1.5rem"}}>
                            <span className="sr-only">Loading...</span>
                          </div>
                        :
                          <i className="fa fa-print" />
                        }
                          &nbsp; {this.lang("Authorize PDF")}
                        </button> */}
                        {/* <button className={`glass btn btn-lg pull-right mr-1 btn-danger`} onClick={() => this.DATpdfGenerate()}>
                        {this.state.DATLoading ? 
                          <div className="spinner-border" role="status" style={{width : "1.5rem", height : "1.5rem"}}>
                            <span className="sr-only">Loading...</span>
                          </div>
                        :
                          <i className="fa fa-print" />
                        }
                          &nbsp; {this.lang("pdfAuthorizeForsilverDAT")}
                        </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </CardHeader>
          </Card>
            <Card>
            <CardBody>
                  <Newswiss_CustomerInfoTable viewType='TabView' Authorized={this.state.Authorized} getJSONData={(vin) => this.getData(vin)}/>
               
                  {/* Reference Component :: SwissPriceTable */}
                  {isJSONLoading  ?
                    <div className="container mt-50 damage-summary-section p-0">
                     <div className="row p-0">
                      <div className="col-12 text-center">
                          <h4 className="text-center">Loading...</h4>
                        </div>
                      </div>
                    </div>
                  :
                      <NewpolandPriceTable
                        vinfolderList={this.state.swissTableCH}
                        viewType="TabView" 
                        getUpdatedStateFromPriceTable = {(data)=>this.getUpdatedStateFromPriceTable(data)}
                        Authorized={this.state.Authorized}
                      />
                  }
                {/* <NewOneSwissPriceTable
                  vinfolderList={this.state.swissTableCH}
                  viewType="TabView" 
                  getUpdatedStateFromPriceTable = {(data)=>this.getUpdatedStateFromPriceTable(data)}
                /> */}
            </CardBody>
          </Card>
        </Col>
        <DuplicateVinModal 
        duplicateVinModal={duplicateVinModal}
        openDuplicateVinModal={this.openDuplicateVinModal}
        selectedPartnerIdList={selectedPartnerIdList}
        handleSelectedPartnerId={this.handleSelectedPartnerId}
        selectedPartnerId={selectedPartnerId}
        lang={this.lang}
        />
      </div>
    );
  }
}
const mapDispatchtoProps = (dispatch) => {
  return {
    toggleDamageImages: (show) => dispatch(toggleDamageImages(show)),
    updateJsonData: (data) => dispatch(updateJsonData(data)),
  };
};
const mapStateToProps = (props) => {
  return {
    fullData : props.jsonData,
    selectedPartnerId: props.selectedPartnerId.duplicateSelectedPartnerId,
    isDuplicateVin: props.selectedPartnerId.isDuplicateVin,
  };
};
export default connect(mapStateToProps,mapDispatchtoProps)(TabViewPoland);

